import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import modules from './modules'
Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  state: {
    api: axios.create({baseURL: process.env.VUE_APP_API}),
    loading: false
  },
  getters: {
    api: state => state.api,
    loading: state => state.loading,
    loading_helper: state => state.loading_helper
  },
  mutations: {
    SET_LOADING: (state, payload) => state.loading = payload,
    SET_LOADING_HELPER: (state, payload) => state.loading_helper = payload,
  },
  actions: {
    index({commit, state}, payload) {
      commit('SET_LOADING', true);
      return new Promise((res,rej) => {
        state.api.get(payload.endpoint, {params: payload.params?payload.params:{}})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })
        .then(() => {
          commit('SET_LOADING', false)
        })
      });
    },
    helper({commit, state}, payload) {
      commit('SET_LOADING_HELPER', true);
      return new Promise((res,rej) => {
        state.api.get(payload.endpoint, {params: payload.params?payload.params:{}})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })
        .then(() => {
          commit('SET_LOADING_HELPER', false)
        })
      });
    },
    save({commit, state}, payload) {
      commit('SET_LOADING', true);
      return new Promise((res, rej) => {
        state.api.post(payload.endpoint, payload.params?payload.params:{})
          .then((response) => {
            res(response.data)
          })
          .catch((error) => {
            rej(error)
          })
          .then(() => {
            commit('SET_LOADING', false)
          })
      })
    },
  }
})
